import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang, useRouter, useState, useEffect, Link } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);

    const cards = [
        {
            text: t('J_card1_text'),
            author: t('J_card1_author'),
        },
        {
            text: t('J_card2_text'),
            author: t('J_card2_author'),
        },
        {
            text: t('J_card3_text'),
            author: t('J_card3_author'),
        },
        {
            text: t('J_card4_text'),
            author: t('J_card4_author'),
        },
        {
            text: t('J_card5_text'),
            author: t('J_card5_author'),
        },
        {
            text: t('J_card6_text'),
            author: t('J_card6_author'),
        },
    ];

    if (locale == 'kr') {
        cards.pop();
    }

    let IMGS = [
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080668822/10_1.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080682461/10_2.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080692751/10_3.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080700757/10_4.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080709959/10_5.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080718355/10_6.jpg',
    ];

    if (locale == 'kr') {
        IMGS = [
            'https://websiteoss.ecoflow.com/upload/image/1720683941756/blog_kr_1.png',
            'https://websiteoss.ecoflow.com/upload/image/1720683942389/blog_kr_2.png',
            'https://websiteoss.ecoflow.com/upload/image/1720683942599/blog_kr_3.png',
            'https://websiteoss.ecoflow.com/upload/image/1720683941922/blog_kr_4.png',
            'https://websiteoss.ecoflow.com/upload/image/1720683942123/blog_kr_5.png',
        ];
    }

    useEffect(() => {
        setGap(window.innerWidth > 1440 ? 24 : window.innerWidth > 1024 ? 20 : 12);
    }, []);

    return (
        <div id="RV-J" className={`RV-J RV-box ${css['RV-J']}`}>
            <div className="info-box">
                <p className="title">{t('J_title')}</p>
                <p className="desc">{t('J_desc')}</p>
            </div>
            <Swiper className="cards swiper-box" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <div className="card-img">
                            <EFPicture src={IMGS[k]} alt={card?.text} />
                        </div>
                        <div className="card-info">
                            <p className="card-text">{card.text}</p>
                            <p className="card-author">{card.author}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <Link
                href={locale === 'za' ? 'https://bit.ly/3WAr7DJ' : locale === 'au' ? 'https://www.facebook.com/ecoflowaustralia' : 'https://bit.ly/49eIE9d'}
                className="facebook"
                target="_blank"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'activity_join_facebook',
                    button_name: t('J_facebook'),
                }}
            >
                {t('J_facebook')}
            </Link>
            {locale === 'us' && (
                <Link
                    href={`https://${locale}.ecoflow.com/pages/ecoflow-exhibition-events`}
                    className="calendar"
                    target="_blank"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: 'RV',
                        list_name: t('J_title'),
                        button_name: t('J_calendar'),
                        function: 'Offline Event Calender',
                    }}
                >
                    <span className="text">{t('J_calendar')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                            d="M6.75651 2.85889L12.0898 8.19222L6.75651 13.5256"
                            stroke="#3F68E0"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Link>
            )}
        </div>
    );
}
